import React, { useMemo } from 'react';
import _ from 'lodash';
import { Carousel } from 'react-responsive-carousel';
import { MobileBannerCarouselStyled } from './styled/MobileBannerCarouselStyled';
import { useSelector } from 'react-redux';
import { getIsLocationPlatformDesktopSelector } from '../../../modules/Location/locationSelectors';
import ButtonMove from '../../../components/ButtonMove/ButtonMove';


interface IMobileBannerCarousel {
    children: JSX.Element | JSX.Element[] | false;
    className?: string,
}

const MobileBannerCarousel = (props: IMobileBannerCarousel) => {
    const { children, className } = props;

    const parsedChildren = useMemo(() => Array.isArray(children)
            ? children.filter(elem => !!elem) as JSX.Element[]
            : children
                ? [children]
                : [],
        [children]);
    const isIndicatorShow = parsedChildren.length > 1;
    const isDesktop = useSelector(getIsLocationPlatformDesktopSelector);

    if (_.isEmpty(parsedChildren)) {
        return null;
    }

    return <MobileBannerCarouselStyled isIndicatorShow={isIndicatorShow} className={className}>
        <Carousel
            key={`mobile-profile${parsedChildren.length}`} // fix close slides
            preventMovementUntilSwipeScrollTolerance
            showArrows={isDesktop}
            showStatus={false}
            showThumbs={false}
            showIndicators={parsedChildren.length > 1}
            renderArrowPrev={(onClickHandler) => isIndicatorShow && isDesktop &&
                <ButtonMove size={'xs'} className={'arrow-left'} direction={'left'}
                            onClick={onClickHandler}/>}
            renderArrowNext={(onClickHandler) => isIndicatorShow && isDesktop &&
                <ButtonMove size={'xs'} className={'arrow-right'} direction={'right'}
                            onClick={onClickHandler}/>}
        >
            {parsedChildren}
        </Carousel>
    </MobileBannerCarouselStyled>;
};

export default MobileBannerCarousel;
